import { render, staticRenderFns } from "./ArticleUpdate.vue?vue&type=template&id=0e3916f5&"
import script from "./ArticleUpdate.vue?vue&type=script&lang=js&"
export * from "./ArticleUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports